// =====================================================================
// COSMETICA BEAUTY AWARDS 2027 — المحتوى بالعربية
// جميع نصوص الموقع موجودة هنا. لإضافة الإنجليزية / الفرنسية:
// كرّر هذا الملف (content.en.js / content.fr.js) وسجّله في src/content/index.js
// لا حاجة لتعديل أيّ مكوّن.
// =====================================================================

const content = {
  lang: "ar",

  site: {
    name: "COSMETICA BEAUTY AWARDS",
    year: "2027",
    // Ouverture des candidatures (heure d'Alger, UTC+1). Le basculement /candidater est automatique.
    openingDate: "2026-11-10T00:00:00+01:00",
    applyUrl: "https://awards.cosmeticaafrica.com",
    applyDomain: "awards.cosmeticaafrica.com",
  },

  seo: {
    home: {
      title: "COSMETICA BEAUTY AWARDS 2027 — نحتفي بتميّز الجمال",
      description:
        "تحتفي COSMETICA BEAUTY AWARDS بالمنتجات والعلامات التجارية التي تتميّز بجودتها وإبداعها وابتكارها. دورة 2027: سيفتح باب الترشحات قريباً.",
    },
    categories: {
      title: "فئات 2027 — COSMETICA BEAUTY AWARDS",
      description: "15 فئة تغطي أبرز مجالات الجمال، من أفضل منتج عناية بالبشرة إلى COSMETICA Beauty Product of the Year.",
    },
    finalists: {
      title: "المتأهّلون إلى النهائيات — COSMETICA BEAUTY AWARDS 2027",
      description: "الإعلان عن المتأهّلين إلى النهائيات مبرمج في 15 مارس 2027.",
    },
    winners: {
      title: "الفائزون — COSMETICA BEAUTY AWARDS 2027",
      description: "سيُكشف عن الفائزين في نهاية أفريل 2027 خلال الحفل الرسمي.",
    },
    apply: {
      title: "ترشّح — COSMETICA BEAUTY AWARDS 2027",
      description: "سيفتح باب الترشحات قريباً. كن أوّل من يعلم بتاريخ 10 نوفمبر 2026.",
    },
    contact: {
      title: "تواصل معنا — COSMETICA BEAUTY AWARDS 2027",
      description: "تواصل مع فريق COSMETICA BEAUTY AWARDS.",
    },
  },

  a11y: {
    home: "COSMETICA BEAUTY AWARDS — الرئيسية",
    mainNav: "التنقل الرئيسي",
    mobileNav: "التنقل على الهاتف",
    language: "اللغة",
  },

  nav: {
    items: [
      { label: "الجوائز", hash: "essence" },
      { label: "الفئات", to: "/categories" },
      { label: "المسار", hash: "parcours" },
      { label: "المواعيد", hash: "dates" },
      { label: "لجنة التحكيم", hash: "jury" },
      { label: "المعايير", hash: "criteres" },
      { label: "المتأهّلون", to: "/finalistes" },
      { label: "الفائزون", to: "/gagnants" },
    ],
    cta: { label: "ترشّح", to: "/candidater" },
    tabs: [
      { label: "الرئيسية", to: "/", icon: "Home" },
      { label: "الفئات", to: "/categories", icon: "LayoutGrid" },
      { label: "المواعيد", hash: "dates", icon: "CalendarDays" },
      { label: "لجنة التحكيم", hash: "jury", icon: "Users" },
      { label: "ترشّح", to: "/candidater", icon: "Award" },
    ],
    menuTitle: "القائمة",
    menuOpen: "افتح القائمة",
    menuClose: "أغلق القائمة",
    skip: "انتقل إلى المحتوى",
  },

  ui: {
    discover: "اكتشف",
    contactTeam: "تواصل مع الفريق",
    beNotified: "أشعِرني",
    apply: "ترشّح",
    edition: "دورة 2027",
    seeAll: "اطّلع على جميع الفئات",
    seeFinalists: "اطّلع على صفحة المتأهّلين",
    seeWinners: "اطّلع على صفحة الفائزين",
    nextDate: "الموعد القادم",
    scrollHint: "مرّر للأسفل",
    prev: "السابق",
    next: "التالي",
    soon: "قريباً",
    index: "المحتويات",
    countdown: {
      label: "يفتح باب الترشحات خلال",
      days: "أيام",
      hours: "ساعات",
      minutes: "دقائق",
      seconds: "ثوانٍ",
      open: "باب الترشحات مفتوح.",
    },
    emptyProduct: { name: "اسم المنتج", brand: "العلامة التجارية", category: "الفئة" },
    footer: { rights: "COSMETICA BEAUTY AWARDS 2027", credit: "الموقع من إنجاز", agency: "SOURATI DIGITAL", agencyUrl: "https://sourati.digital/" },
  },

  hero: {
    brand: "COSMETICA BEAUTY AWARDS",
    lines: ["COSMETICA", "BEAUTY AWARDS"],
    tagline: "نحتفي بتميّز الجمال",
    edition: "دورة 2027",
    status: "سيفتح باب الترشحات قريباً.",
    text: "تكريم مخصّص للمنتجات والعلامات التجارية والصنائع التي تُسهم في صياغة جمال الغد.",
    imageAlt: "قارورة عطر من الزجاج موضوعة على قماش داكن، بإضاءة ناعمة",
  },

  marquee: ["نحتفي بتميّز الجمال", "COSMETICA BEAUTY AWARDS", "دورة 2027"],

  essence: {
    id: "essence",
    eyebrow: "الجوائز",
    title: "جوهر الجوائز",
    paragraphs: [
      "تحتفي COSMETICA BEAUTY AWARDS بالمنتجات والعلامات التجارية التي تتميّز بجودتها وإبداعها وابتكارها وقدرتها على مواكبة تطوّرات سوق التجميل.",
      "من خلال باقة فئات تغطّي أبرز مجالات الجمال، تتيح الجوائز للعلامات التجارية منصّة لعرض منتجاتها وإبراز خبراتها والاستفادة من أنظار المختصّين في القطاع.",
      "صُمّمت الجوائز في قلب منظومة COSMETICA AFRICA لتجمع بين العلامات والمصنّعين والخبراء والموزّعين والمشترين والمهنيّين حول هدف واحد: إبراز المنتجات الجديرة بالاكتشاف والاعتراف والظهور.",
    ],
    imageAlt: "قوارير عناية مرتّبة على رفّ، بإضاءة ناعمة",
  },

  why: {
    id: "pourquoi",
    eyebrow: "لماذا تشارك",
    title: "لماذا تشارك؟",
    intro:
      "المشاركة في COSMETICA BEAUTY AWARDS تمنح منتجك فرصة للتميّز، وللقاء أنظار جديدة، ولنيل التقدير الذي يستحقّه العمل الذي يكمن وراءه.",
    items: [
      { title: "تقييم من مختصّين", text: "يُعرض منتجك على لجنة تحكيم مكوّنة من مهنيّين ذوي خبرات متنوّعة ينتمون إلى مجالات مختلفة من صناعة التجميل." },
      { title: "حضور إعلامي أوسع", text: "يُسلَّط الضوء على المتأهّلين والفائزين عبر موقع COSMETICA BEAUTY AWARDS ومنصات COSMETICA AFRICA على شبكات التواصل الاجتماعي، من خلال محتويات مخصّصة للاختيار وللفائزين." },
      { title: "الاكتشاف ضمن منظومة الجمال", text: "ينضمّ منتجك إلى بيئة مهنية تجمع بين العلامات التجارية والمصنّعين والموزّعين والمشترين والخبراء، في قلب منظومة COSMETICA." },
      { title: "حضور في معرض الجوائز", text: "تندمج المنتجات المتأهّلة ضمن الاختيار الرسمي لـ COSMETICA BEAUTY AWARDS وتُعرض في فضاء مخصّص طوال أربعة أيام من COSMEORAN 2027 ثم COSMETICA AFRICA 2028. ويمنح ذلك المنتجات الفائزة حضوراً فعلياً أمام زوّار الحدثين." },
      { title: "تكريم رسمي", text: "يحصل المتأهّلون والفائزون على عناصر تواصل رسميّة تتيح لهم إبراز تكريمهم." },
      { title: "تقدير يتجاوز حدود الجائزة", text: "يمكن أن يُغني الاختيارُ أو الفوزُ تواصلَكم وسردَ قصّة منتجكم وعلاقاتَكم الصحفية وعلاقاتَكم مع الشركاء والموزّعين والمشترين." },
    ],
  },

  who: {
    id: "participer",
    eyebrow: "الأهلية",
    title: "من يحقّ له المشاركة؟",
    intro: "تستهدف COSMETICA BEAUTY AWARDS فاعلي الجمال الراغبين في إبراز منتجاتهم وصنائعهم.",
    listTitle: "يمكن أن يشارك خصوصاً",
    list: [
      "العلامات التجارية للجمال",
      "المصنّعون والمخابر التجميلية",
      "علامات العناية بالبشرة",
      "علامات العناية بالشعر",
      "علامات المكياج",
      "علامات العطور",
      "علامات العناية بالجسم",
      "علامات النظافة والعناية الشخصية",
      "علامات الجمال الاحترافي",
      "العلامات التجارية الناشئة",
      "العلامات التجارية الراسخة",
      "الشركات المحلّية والدولية",
    ],
    note: "قد تختلف شروط الأهلية بحسب الفئة.",
    faq: [
      {
        q: "هل يمكن لعلامة تجارية المشاركة دون أن تكون عارضة في COSMETICA AFRICA؟",
        a: "نعم، وفقاً للشروط الرسمية للمشاركة. صُمّمت COSMETICA BEAUTY AWARDS لتجمع طيفاً واسعاً من فاعلي الصناعة وتكشف عن منتجات من أسواق متنوّعة.",
      },
    ],
    nb: "ملاحظة: تُحدَّد المعايير النهائية للأهلية ومواعيد الانطلاق وشروط المشاركة في اللائحة الرسمية للجوائز.",
  },

  categories: {
    id: "categories",
    eyebrow: "دورة 2027",
    title: "فئات 2027",
    pageIntro: "15 فئة",
    items: [
      { n: "01", title: "BEST SKINCARE PRODUCT", text: "منتج عناية يتميّز بتركيبته وأدائه وتجربة استخدامه واستجابته لاحتياجات البشرة الراهنة." },
      { n: "02", title: "BEST HAIRCARE PRODUCT", text: "منتج عناية أو علاج أو تصفيف يقدّم استجابةً فعّالة وملائمة لحاجة الشعر وفروة الرأس." },
      { n: "03", title: "BEST MAKEUP PRODUCT", text: "منتج مكياج يتألّق بجودته ونتيجته وثباته وتركيبته وتجربة استخدامه." },
      { n: "04", title: "BEST FRAGRANCE", text: "عطر يحمل هوية شذوية مميّزة، بتركيبة عالية الجودة وعالم متناسق." },
      { n: "05", title: "BEST BODY CARE PRODUCT", text: "منتج مخصّص للعناية بالجسم ورفاهيته، يجمع بين الفعالية وجودة التركيبة والتجربة الحسّية." },
      { n: "06", title: "BEST PERSONAL CARE PRODUCT", text: "منتج عناية أو نظافة شخصية يستجيب بشكل ملائم لاستعمالات المستهلكين وتوقّعاتهم." },
      { n: "07", title: "BEST MEN'S GROOMING PRODUCT", text: "منتج مخصّص للعناية الرجالية والاهتمام بالوجه أو الجسم أو اللحية، يجمع بين الفعالية والجودة والعمليّة في الحياة اليوميّة." },
      { n: "08", title: "BEST PROFESSIONAL BEAUTY PRODUCT", text: "منتج مصمَّم لمختصّي الجمال، يستجيب لاحتياجاتهم الخصوصية ولمتطلّبات ممارستهم." },
      { n: "09", title: "BEST NATURAL & BOTANICAL PRODUCT", text: "منتج يستند إلى مكوّنات من أصل طبيعي أو نباتي، بتركيبة متناسقة ومقاربة واضحة." },
      { n: "10", title: "BEAUTY INNOVATION AWARD", text: "ابتكار يقدّم مقاربةً أو تكنولوجيا أو تطبيقاً جديداً، ويستجيب بطريقة أصيلة لحاجة في القطاع." },
      { n: "11", title: "BEST PACKAGING DESIGN", text: "تغليف يجمع بين الجماليّة والوظيفيّة والإبداع والتناسق مع هوية المنتج." },
      { n: "12", title: "BEST SUSTAINABLE BEAUTY PRODUCT", text: "منتج يدمج مقاربةً مسؤولة من خلال تركيبته أو موادّه أو تغليفه أو تصميمه أو دورة حياته." },
      { n: "13", title: "BEST NEW PRODUCT LAUNCH", text: "إطلاق حديث يحمل مفهوماً مميّزاً وموقعاً واضحاً وعرضاً ملائماً للسوق." },
      { n: "14", title: "MADE IN ALGERIA BEAUTY AWARD", text: "منتج مصمَّم ومطوَّر في الجزائر، يعكس جودة الصناعة الجزائريّة للجمال وإبداعها وخبرتها." },
    ],
    grandPrix: {
      n: "15",
      label: "الجائزة الكبرى",
      title: "COSMETICA BEAUTY PRODUCT OF THE YEAR",
      text: "يُمنح اللقب الأبرز في النسخة، وهو الجائزة الكبرى لـ COSMETICA BEAUTY AWARDS، للمنتج الذي يقدّم أبرز تميّز شامل من حيث الجودة والمفهوم والتنفيذ والملاءمة.",
      imageAlt: "قارورة عطر على قماش فاتح، بإضاءة ذهبيّة",
    },
    nb: "ملاحظة: تُحدَّد الفئات والعناوين ومعايير الأهلية وأيّ تعديلات للفئات في اللائحة الرسمية لدورة 2027.",
  },

  journey: {
    id: "parcours",
    eyebrow: "المسار",
    title: "المسار نحو COSMETICA BEAUTY AWARDS",
    steps: [
      { n: "01", title: "ترشّح", text: "اختر فئتك وأكمل ملفّ مشاركتك بالمعلومات المطلوبة." },
      { n: "02", title: "التحقّق من الأهلية", text: "تُفحص كلّ ترشّح وفقاً للشروط المطبَّقة على الفئة المختارة." },
      { n: "03", title: "إرسال المنتج", text: "يرسل المرشّحون المؤهّلون العينات والعناصر المطلوبة للتقييم." },
      { n: "04", title: "التقييم", text: "تُدرس المنتجات وفق المعايير المحدَّدة لفئتها من قبل أعضاء لجنة التحكيم." },
      { n: "05", title: "المتأهّلون", text: "يُعلَن رسمياً عن المنتجات المختارة للنهائيات، وتُسلَّط عليها الأضواء عبر منصّات الجوائز." },
      { n: "06", title: "التقييم النهائي", text: "يخضع المتأهّلون للتقييم النهائي وفق المنهجيّة المطبَّقة على فئتهم." },
      { n: "07", title: "الحفل", text: "يُكشف عن الفائزين خلال الحفل الرسمي لـ COSMETICA BEAUTY AWARDS 2027." },
    ],
  },

  dates: {
    id: "dates",
    eyebrow: "الروزنامة",
    title: "المواعيد الرئيسية",
    items: [
      { date: "30 أكتوبر 2026", end: "2026-10-30", title: "الإعلان عن الجوائز", text: "العرض الرسمي لدورة 2027 وانطلاق التواصل." },
      { date: "10 نوفمبر 2026", end: "2026-11-10", title: "افتتاح باب الترشحات", text: "تبدأ العلامات التجارية في تقديم منتجاتها." },
      { date: "15 جانفي 2027", end: "2027-01-15", title: "إغلاق باب الترشحات", text: "آخر أجل لتقديم الترشّح." },
      { date: "31 جانفي 2027", end: "2027-01-31", title: "الموعد النهائي لوصول العينات", text: "يجب أن تكون المنتجات المطلوبة قد أُرسلت ضمن الآجال المحدَّدة." },
      { date: "فيفري – بداية مارس 2027", end: "2027-03-10", title: "المرحلة الأولى من التقييم", text: "يقيّم أعضاء لجنة التحكيم الترشّحات وفق المعايير المحدَّدة." },
      { date: "15 مارس 2027", end: "2027-03-15", title: "الإعلان عن المتأهّلين", text: "تتأهّل المنتجات المختارة إلى النهائيات." },
      { date: "مارس – بداية أفريل 2027", end: "2027-04-10", title: "التقييم النهائي", text: "المرحلة الأخيرة قبل اختيار الفائزين." },
      { date: "نهاية أفريل 2027", end: "2027-04-30", title: "حفل الجوائز", text: "الكشف عن الفائزين والاحتفاء بتميّز الجمال." },
    ],
    nb: "ملاحظة: تواريخ سيُؤكَّد عليها في الروزنامة الرسمية لدورة 2027.",
  },

  jury: {
    id: "jury",
    eyebrow: "لجنة التحكيم",
    title: "لجنة التحكيم",
    intro: [
      "تستند مصداقيّة أيّ جائزة إلى جودة الأنظار التي تقيّم المنتجات.",
      "ستجمع COSMETICA BEAUTY AWARDS لجنة تحكيم متعدّدة التخصّصات، مكوّنة من مهنيّين ينتمون إلى مجالات متنوّعة في الجمال وفي تخصّصات متكاملة.",
    ],
    profilesTitle: "بحسب الفئات، يمكن أن تضمّ اللجنة خصوصاً:",
    profiles: [
      "التركيبة والبحث",
      "تطوير المنتجات",
      "التجميل والعطور",
      "الجمال الاحترافي",
      "تجارة التجزئة والتوزيع",
      "التسويق وبناء العلامة التجارية",
      "التغليف والتصميم",
      "الابتكار والتكنولوجيات",
      "الإعلام والخبرة في مجال الجمال",
    ],
    outro: "يتيح هذا التنوّع في الزوايا تقييم المنتجات من عدّة جوانب، مع الأخذ بعين الاعتبار جودتها الذاتيّة وملاءمتها لبيئتها السوقيّة.",
    banner: "تركيبة لجنة التحكيم ستُعلَن قريباً",
    portraitSlots: 8,
    members: [], // { name, role, photo } — à renseigner à l'annonce du jury
    nb: "ملاحظة: ستُعلَن التركيبة النهائية للجنة رسمياً عبر قنوات تواصل COSMETICA BEAUTY AWARDS.",
  },

  criteria: {
    id: "criteres",
    eyebrow: "التقييم",
    title: "معايير التقييم",
    intro: "لكلّ فئة خصوصيّاتها. يمكن أن يأخذ التقييم بعين الاعتبار خصوصاً عدّة أبعاد من المنتج.",
    items: [
      { icon: "Gauge", title: "الفعاليّة والأداء", text: "جودة أداء المنتج وملاءمته بالنظر إلى فئته." },
      { icon: "Sparkles", title: "الابتكار والأصالة", text: "أصالة المفهوم والمقاربة والتركيبة والتكنولوجيا أو التطبيق." },
      { icon: "FlaskConical", title: "التركيبة والتكنولوجيا", text: "جودة التركيبة وإتقانها، وملاءمة المكوّنات، فضلاً عن أداء التكنولوجيات وأنظمة الإطلاق المرافقة للمنتج." },
      { icon: "Hand", title: "تجربة المستخدم", text: "الملمس والحسّية وسهولة الاستخدام والعمليّة والتجربة الكلّية بحسب طبيعة المنتج." },
      { icon: "Package", title: "التغليف والتصميم", text: "الوظيفيّة وبيئة الاستخدام والهوية البصريّة والتناسق الجمالي وجودة التنفيذ." },
      { icon: "BookOpen", title: "المفهوم والسرد", text: "وضوح الموقع، وتناسق الهوية، وقدرة بناء سرد مميّز ومتناسق." },
      { icon: "Target", title: "ملاءمة السوق", text: "التوافق مع توقّعات المستهلكين والاستعمالات وتطوّرات القطاع." },
      { icon: "Leaf", title: "المسؤولية", text: "الأخذ بعين الاعتبار الأبعاد البيئية والأخلاقية والمسؤولة حين تكون ذات صلة بالفئة." },
    ],
    nb: "ملاحظة: قد تختلف المعايير وأوزانها بحسب الفئات، وستُفصَّل في اللائحة وفي المنهجيّة الرسمية.",
  },

  finalists: {
    id: "finalistes",
    eyebrow: "الاختيار",
    title: "أن تكون متأهّلاً يعني أن تكون محلّ تقدير",
    status: "الإعلان متوقَّع في 15 مارس 2027",
    intro: "الوصول إلى المرحلة النهائية من COSMETICA BEAUTY AWARDS يعني أن منتجك اختير من ضمن الترشّحات التي خضعت للتقييم في فئته.",
    listTitle: "ما يمكن أن يحصل عليه المتأهّلون",
    items: [
      { title: "صفة رسميّة كمترشّح متأهّل", text: "تقدير رسمي لاختيارك ضمن دورة 2027." },
      { title: "عناصر بصريّة مخصّصة للمتأهّلين", text: "عناصر بصريّة مخصّصة للتواصل حول اختيارك." },
      { title: "حضور رقمي", text: "إبراز على منصّات COSMETICA BEAUTY AWARDS." },
      { title: "حضور في الموقع الرسمي", text: "عرض المنتج ضمن الاختيار الرسمي للمتأهّلين." },
      { title: "AWARDS GALLERY", text: "إدراج المنتج في المعرض الرسمي للجوائز." },
      { title: "حضور في الحفل", text: "دعوة إلى الحفل الرسمي لـ COSMETICA BEAUTY AWARDS، وفق الشروط المحدَّدة من المنظّمين." },
    ],
    products: [], // { image, name, brand, category } — grille prête à recevoir les produits
    imageAlt: "قوارير عناية على سطح داكن، بإضاءة استوديو",
  },

  winners: {
    id: "gagnants",
    eyebrow: "الفائزون",
    title: "الفائزون",
    status: "يُكشف عنهم في نهاية أفريل 2027",
    intro: "يمنح الفوز في COSMETICA BEAUTY AWARDS المنتجَ تقديراً رسمياً ضمن منظومة مهنية مخصّصة للجمال.",
    listTitle: "يمكن للفائزين الاستفادة من",
    items: [
      { title: "كأس رسمي", text: "تكريم مادّي يحتفي بالفوز." },
      { title: "شهادة WINNER", text: "تقدير رسمي للفوز في الفئة المعنيّة." },
      { title: "WINNER MARK", text: "عنصر تمييز مخصّص لتواصل الفائز، وفق قواعد الاستخدام الرسمية." },
      { title: "تواصل رقمي", text: "إعلان وإبراز الفائزين على منصّات الجوائز." },
      { title: "حضور في الموقع الرسمي", text: "عرض المنتج الفائز ضمن الاختيار الرسمي للفائزين." },
      { title: "محتوى تحريري", text: "إمكانيّات إبراز من خلال المحتويات المخصّصة للفائزين." },
      { title: "صور ومحتوى الجوائز", text: "تعزيز قيمة المنتج وتكريمه في المحتويات الرسمية، وفق الآليات المعتمدة." },
      { title: "حضور في منظومة COSMETICA", text: "تقدير يمكن تعزيزه في تواصل العلامة مع شركائها وموزّعيها ومشتريها ومختصّيها." },
    ],
    products: [],
    nb: "ملاحظة: يخضع استخدام WINNER MARK على المنتجات والتغليفات والوسائل التجاريّة للشروط وقواعد الاستخدام الرسمية لـ COSMETICA BEAUTY AWARDS، وكذلك للتشريعات المعمول بها.",
  },

  ecosystem: {
    id: "ecosysteme",
    eyebrow: "المنظومة",
    title: "في قلب منظومة COSMETICA",
    intro: "تندرج COSMETICA BEAUTY AWARDS ضمن منظومة مهنية مكرّسة لتطوير صناعة الجمال في إفريقيا.",
    items: [
      { icon: "Landmark", title: "COSMETICA AFRICA", text: "موعد مهني يجمع العلامات التجارية والمصنّعين والمورّدين والموزّعين والمشترين ومختصّي الجمال." },
      { icon: "Handshake", title: "COSMETICA CONNECT", text: "برنامج مخصّص للقاءات B2B وللتواصل مع متّخذي القرار والمشترين المؤهَّلين." },
      { icon: "ShoppingBag", title: "مشترون ومستهلكون", text: "مختصّون يبحثون عن منتجات وعلامات تجارية وفرص تجاريّة جديدة." },
      { icon: "Truck", title: "الموزّعون", text: "فاعلون يبحثون عن علامات تجارية جديدة ومنتجات لإدماجها في أسواقهم." },
      { icon: "Users", title: "مختصّو الصناعة", text: "خبراء ومهنيّون ينتمون إلى قطاعات مختلفة في صناعة الجمال." },
    ],
    outro: "تُكمل COSMETICA BEAUTY AWARDS بذلك رسالة COSMETICA AFRICA: خلق روابط بين المنتجات والمهنيّين والأسواق.",
  },

  finalCall: {
    id: "contact",
    title: "COSMETICA BEAUTY AWARDS 2027",
    tagline: "نحتفي بتميّز الجمال",
    keyDatesTitle: "المواعيد الرئيسية",
    keyDates: [
      { label: "افتتاح باب الترشحات", value: "10 نوفمبر 2026" },
      { label: "الموعد النهائي للترشّح", value: "15 جانفي 2027" },
    ],
    applyOn: "ترشّح عبر",
    teamTitle: "فريق الجوائز",
    // Coordonnées modifiables : laisser vide ("") pour masquer la ligne.
    team: { email: "", phone: "", other: "" },
    teamLabels: { email: "البريد الإلكتروني", phone: "الهاتف", other: "آخر" },
    teamPending: "سيُضاف لاحقاً",
  },

  contactPage: {
    eyebrow: "تواصل",
    title: "تواصل مع الفريق",
  },

  applyPage: {
    eyebrow: "دورة 2027",
    closedTitle: "سيفتح باب الترشحات قريباً",
    closedText: "افتتاح باب الترشحات: 10 نوفمبر 2026.",
    openTitle: "باب الترشحات مفتوح",
    openText: "ترشّح عبر awards.cosmeticaafrica.com",
    openButton: "ترشّح الآن",
  },

  forms: {
    notify: {
      title: "أشعِرني عند افتتاح باب الترشحات",
      email: "عنوان البريد الإلكتروني",
      brand: "اسم العلامة التجارية (اختياري)",
      submit: "أشعِرني",
      sending: "جارٍ الإرسال…",
      success: "شكراً لك. تمّ تسجيل عنوانك: سنُشعرك عند افتتاح باب الترشحات.",
    },
    contact: {
      title: "تواصل مع الفريق",
      name: "الاسم",
      email: "عنوان البريد الإلكتروني",
      phone: "الهاتف",
      brand: "العلامة التجارية",
      message: "الرسالة",
      submit: "إرسال",
      sending: "جارٍ الإرسال…",
      success: "شكراً لك. تمّ إرسال رسالتك. سيردّ عليك الفريق قريباً.",
    },
    errors: {
      required: "هذا الحقل مطلوب.",
      email: "عنوان البريد الإلكتروني غير صالح.",
      server: "حدث خطأ. يرجى المحاولة مجدّداً.",
    },
  },

  pages: {
    categories: { eyebrow: "دورة 2027", title: "فئات 2027" },
    finalists: { eyebrow: "الاختيار الرسمي", title: "المتأهّلون" },
    winners: { eyebrow: "دورة 2027", title: "الفائزون" },
  },

  notFound: { title: "الصفحة غير موجودة", back: "العودة إلى الرئيسية" },
};

export default content;
